gsap.utils.toArray(".fade").forEach((element) => {
  const split = SplitText.create(element, {
    type: "words",
    wordsClass: "fade-word"
  });
  gsap.fromTo(
    split.words,
    {
      opacity: 0,
      x: -10,
      filter: "blur(10px)"
    },
    {
      opacity: 1,
      x: 0,
      filter: "blur(0px)",
      duration: 1.5,
      stagger: 0.15,
      ease: "power2.out",
      scrollTrigger: {
        trigger: element,
        start: "top 85%",
        toggleActions: "play none none none"
      }
    }
  );
});